<template>
  <div class="app-page one-chat bulma-dropdown">
    <vue-headful title="ALICE | Chatlogs"></vue-headful>
    <div class="column-wrapper">
      <div class="single-page-full">
        <div class="navbar-wrapper">
          <nav class="navbar" role="navigation">
            <div class="navbar-start">
              <div class="navbar-item">
                <label class="label title-label no-margin">1 on 1 Chats</label>
              </div>
            </div>
            <div class="navbar-end">
              <div class="navbar-item">
                <div class="buttons">
                  <button class="button" v-for="ch in channelList" :key="ch" @click="changeChannel(ch)" :class="{ 'is-info': currentChannel === ch }">
                    {{ ch | capitalize }}
                  </button>
                </div>
              </div>
            </div>
          </nav>
        </div>
        <div class="page-content">
          <div class="conversation-list">
            <div class="search-box">
              <div class="field is-grouped">
                <div class="control is-expanded search-bar">
                  <input
                    class="input is-small"
                    type="text"
                    placeholder="Search for chat and message"
                    v-model="logSearchInput"
                    @input="getSearchInput"
                    @keyup="resetSelectedState"
                  />
                </div>
                <div class="control">
                  <b-dropdown aria-role="list" position="is-bottom-left">
                    <a class="button is-small is-white change-conversation-btn" slot="trigger" role="button">
                      <font-awesome-icon icon="bars"></font-awesome-icon>
                    </a>
                    <b-dropdown-item aria-role="listitem" class="chat-menu-item">
                      <span>All</span>
                      <span class="is-pulled-right">
                        <font-awesome-icon icon="check"></font-awesome-icon>
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem" class="chat-menu-item">
                      <span>Active chat</span>
                    </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem" class="chat-menu-item">
                      <span>Archive chat</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div id="user-list" class="list-wrapper">
              <!-- <virtual-list :size="100" :remain="8" :debounce="200" :onscroll="onUserLogListScroll"> -->
              <div v-for="item of filteredLogList" :key="item.userId">
                <div class="panel-block" :class="{ 'is-active': selectedUserIdLog === item.userId }" @click="selectLog(item.userId)">
                  <article class="media">
                    <div class="media-left">
                      <figure class="image">
                        <img
                          v-if="item.lastMessage.channel === 'facebook'"
                          class="is-circular-image"
                          alt="Channel Image"
                          src="@/assets/images/facebook_logo.png"
                        />
                        <img
                          v-if="item.lastMessage.channel === 'ada'"
                          class="is-circular-image"
                          alt="Channel Image"
                          src="@/assets/images/ada_logo.png"
                        />
                        <img
                          v-if="item.lastMessage.channel === 'line'"
                          class="is-circular-image"
                          alt="Channel Image"
                          src="@/assets/images/line_logo.png"
                        />
                      </figure>
                    </div>
                    <div class="media-content">
                      <div class="content-body">
                        <div class="name-row">
                          <div class="name-row-username">
                            <span class="ellipsis-text no-padding">{{ item.userName }}</span>
                            <span
                              class="badge bg-pink-300 ml-1 noti-dot"
                              v-if="
                                currentChannelUnreadLogList &&
                                  currentChannelUnreadLogList[item.userId] &&
                                  currentChannelUnreadLogList[item.userId].length > 0
                              "
                            >
                              {{ currentChannelUnreadLogList[item.userId].length }}
                            </span>
                          </div>
                          <div class="name-row-time">
                            <small>{{ convertTime(item.lastMessageAt) }}</small>
                          </div>
                        </div>
                        <div class="email-row mb-3">
                          <div class="text-row-text email-row-text">
                            <span class="ellipsis-text" style="height: 16px;">
                              {{ item.userEmail || ' ' }}
                            </span>
                          </div>
                        </div>
                        <div class="text-row">
                          <div class="text-row-text" v-if="item.lastMessage">
                            <span class="ellipsis-text" v-if="item.lastMessage.data && item.lastMessage.data.text">
                              {{ getLogUserByDirection(item) }}
                              {{ item.lastMessage.data.text }}
                            </span>
                            <span
                              class="ellipsis-text"
                              v-else-if="
                                item.lastMessage.type === 'send_alice_rule_based_answer' ||
                                  item.lastMessage.type === 'send_selected_alice_rule_based_answer'
                              "
                            >
                              {{ getLogUserByDirection(item) }}
                              <span v-if="item.lastMessage.data && item.lastMessage.data.answers[0] && item.lastMessage.data.answers[0].text">
                                {{ item.lastMessage.data.answers[0].text }}
                              </span>
                              <span v-else>Send answer</span>
                            </span>
                            <span class="ellipsis-text" v-else-if="item.lastMessage.type === 'send_manual_message'">
                              {{ getLogUserByDirection(item, 'Admin', '') }}
                              {{ getManualLastMessage(item.lastMessage.data) }}
                            </span>
                            <span class="ellipsis-text" v-else-if="item.lastMessage.type === 'send_imagemap'">
                              {{ getLogUserByDirection(item, 'Bot') }} sent a photo.
                            </span>
                            <span class="ellipsis-text" v-else>${{ item.lastMessage.type }}</span>
                          </div>
                          <div class="btn-wrapper">
                            <!-- <a class="archive-btn" title="Archive this conversation">
                              <img class="archive-btn-image" src="@/assets/images/archive.png" alt="archive" />
                            </a> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
              <div class="last-item-block" style="height: 100px">
                <div id="eol-user-list" class="panel-block loading-block" v-show="!loadingLog && !logDone">
                  <span>
                    <i class="fas fa-spinner fa-spin"></i>
                  </span>
                </div>
                <div class="panel-block end-block" v-if="!loadingLog && logDone && filteredLogList.length > 0">
                  <span>You've reach the end.</span>
                </div>
                <div class="panel-block end-block" v-if="!loadingLog && logDone && filteredLogList.length === 0">
                  <span>No log data found.</span>
                </div>
              </div>
              <!-- </virtual-list> -->
            </div>
          </div>
          <div class="conversation-detail">
            <div class="title-bar">
              <label class="label">
                <span>{{ selectedLog.userName || 'Conversation' }} </span>
                <span v-if="selectedLog.userEmail" class="email-title-bar">( {{ selectedLog.userEmail }} )</span>
                <span v-show="loadingDetail">
                  &nbsp;
                  <font-awesome-icon icon="sync-alt" spin></font-awesome-icon>
                </span>
              </label>
              <div class="right-tool">
                <label class="label">
                  <font-awesome-icon icon="search"></font-awesome-icon>
                </label>
                <!-- hide chat mode -->
                <div v-if="!menuConfig.oneOnOneChat.chatMode.isHide" class="btn-group" role="group" aria-label="Chat Mode">
                  <button
                    type="button"
                    class="btn btn-sm control-left-btn"
                    @click="toggleIsBotActive(false)"
                    :class="isBotActive === false ? 'bg-primary' : 'alpha-grey'"
                  >
                    Manual
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm control-right-btn"
                    @click="toggleIsBotActive(true)"
                    :class="isBotActive === true ? 'bg-primary' : 'alpha-grey'"
                  >
                    Auto
                  </button>
                </div>
              </div>
            </div>
            <div class="detail-data">
              <DynamicScroller
                id="detail-scroller"
                ref="detail_scroll"
                class="wrapper-bg custom-scroll-style"
                :emitUpdate="true"
                :items="logDetail.content || []"
                :minItemSize="70"
                @scroll.native.passive="handleScroll"
                :class="{ invincible: loadingFirstDetail }"
              >
                <template slot-scope="{ item, index, active }">
                  <DynamicScrollerItem :item="item" :active="active" :data-index="index" :watchData="true" :size-dependencies="[item.data]">
                    <!--Both-->
                    <text-message
                      v-if="isTextMessage(item) || isManualMessageType(item, 'text_message')"
                      :data="item.data"
                      :direction="item.direction"
                      :time="item.created_at"
                      :image="item.user_image || ''"
                      :channel="item.channel"
                      :isManual="isManualMessageType(item, 'text_message')"
                    />
                    <send-image
                      v-else-if="isImageMessage(item) || isManualMessageType(item, 'image')"
                      :direction="item.direction"
                      :data="item.data"
                      :imgUrlField="getMediaUrlField(item, 'image')"
                      :time="item.created_at"
                      :channel="item.channel"
                    ></send-image>
                    <send-video
                      v-else-if="isVideoMessage(item) || isManualMessageType(item, 'video')"
                      :direction="item.direction"
                      :data="item.data"
                      :videoUrlField="getMediaUrlField(item, 'video')"
                      :time="item.created_at"
                      :channel="item.channel"
                    ></send-video>
                    <send-audio
                      v-else-if="isAudioMessage(item) || isManualMessageType(item, 'audio')"
                      :direction="item.direction"
                      :data="item.data"
                      :audioUrlField="getMediaUrlField(item, 'audio')"
                      :time="item.created_at"
                      :channel="item.channel"
                    ></send-audio>
                    <!--Incoming-->
                    <send-postback-template
                      v-else-if="item.type === 'postback'"
                      :data="item.data"
                      :prevData="logDetail.content[index - 1] || {}"
                      :time="item.created_at"
                      :image="item.user_image || ''"
                      :channel="item.channel"
                    />
                    <send-location
                      v-else-if="item.type === 'location'"
                      :data="item.data"
                      :time="item.created_at"
                      :image="item.user_image || ''"
                      :channel="item.channel"
                    />
                    <!--Outgoing-->
                    <send-rulebase-answer
                      v-else-if="isRuleBasedMessage(item)"
                      :data="item.data"
                      :time="item.created_at"
                      :channel="item.channel"
                      :uid="item.id"
                    ></send-rulebase-answer>
                    <send-quickreply-template
                      v-else-if="isQuickReplyMessage(item)"
                      :data="item.data"
                      :time="item.created_at"
                      :channel="item.channel"
                    />
                    <button-template v-else-if="isButtonTemplateMessage(item)" :data="item.data" :time="item.created_at" :channel="item.channel" />
                    <processing-message
                      v-else-if="item.direction === 'processing'"
                      :messageType="item.type"
                      :data="item.data"
                      :modelList="modelList"
                      :time="item.created_at"
                      :channel="item.channel"
                    />
                    <send-image-map v-else-if="isImageMapMessage(item)" :data="item.data" :time="item.created_at" :channel="item.channel" />
                    <line-flex-carousel-layout
                      v-else-if="isLineFlexCarousel(item)"
                      :data="item.data"
                      :time="item.created_at"
                      :channel="item.channel"
                    />
                    <fb-carousel-layout
                      v-else-if="isFbCarousel(item)"
                      :data="item.data"
                      :time="item.created_at"
                      :channel="item.channel"
                      :uid="item.id"
                    ></fb-carousel-layout>
                    <!--Other-->
                    <div v-else-if="item.type === 'date-separator'" class="date-block">
                      <span class="date-text">{{ item.date }}</span>
                    </div>
                    <div v-else class="generic-block">
                      <span class="generic-text">Type not supported: {{ item.type }}</span>
                    </div>
                  </DynamicScrollerItem>
                </template>
              </DynamicScroller>
              <div class="conv-not-selected" v-if="selectedUserIdLog === null">
                No log selected to view.
              </div>
            </div>
            <!-- hide chat box -->
            <div v-if="!menuConfig.oneOnOneChat.chatMode.isHide" class="chat-box">
              <div class="toolbar">
                <a class="toolbar-btn" :class="{ disabled: isBotActive === true }" @click="mediaModalOpen = true">
                  <font-awesome-icon icon="paperclip"></font-awesome-icon>
                </a>
              </div>
              <textarea
                class="textarea"
                cols="30"
                rows="3"
                :disabled="isBotActive === true"
                v-model="chatTextInput"
                v-on:keydown="handleTextMessageInput"
                :placeholder="isBotActive === true ? 'Disable auto mode to type...' : 'Start typing...'"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <media-modal :open="mediaModalOpen" v-on:onSelect="onFileSelect" v-on:onClose="mediaModalOpen = false"></media-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'underscore';
import io from 'socket.io-client';
// import virtualList from 'vue-virtual-scroll-list';
import dashboardConfig from '../../dashboard-config';

import alice from '../../alice-api';

import textMessage from '../../components/Logs/TextMessage.vue';
import processingMessage from '../../components/Logs/ProcessingMessage.vue';
import buttonTemplate from '../../components/Logs/ButtonTemplate.vue';
import sendPostbackTemplate from '../../components/Logs/SendPostbackTemplate.vue';
import sendQuickReplyTemplate from '../../components/Logs/SendQuickReplyTemplate.vue';
import sendLocation from '../../components/Logs/SendLocation.vue';
import sendImageMap from '../../components/Logs/SendImageMap.vue';
import lineFlexCarouselLayout from '../../components/Logs/Line/FlexCarouselLayout.vue';
import sendRuleBaseAnswer from '../../components/Logs/SendRuleBaseAnswer.vue';
import facebookCarouselLayout from '../../components/Logs/Facebook/FbCarouselLayout.vue';
import sendImage from '../../components/Logs/SendImage.vue';
import sendAudio from '../../components/Logs/SendAudio.vue';
import sendVideo from '../../components/Logs/SendVideo.vue';
import mediaModal from '../../components/Modals/MediaModal.vue';

export default {
  name: 'one-on-one-chat',
  components: {
    // 'virtual-list': virtualList,
    'text-message': textMessage,
    'processing-message': processingMessage,
    'button-template': buttonTemplate,
    'send-postback-template': sendPostbackTemplate,
    'send-quickreply-template': sendQuickReplyTemplate,
    'send-location': sendLocation,
    'send-image-map': sendImageMap,
    'line-flex-carousel-layout': lineFlexCarouselLayout,
    'send-rulebase-answer': sendRuleBaseAnswer,
    'send-image': sendImage,
    'send-audio': sendAudio,
    'send-video': sendVideo,
    'fb-carousel-layout': facebookCarouselLayout,
    'media-modal': mediaModal,
  },
  data() {
    return {
      initScrollStatus: false,
      logSearchInput: '',
      loadingLog: false,
      loadingFirstDetail: false,
      loadingDetail: false,
      currentLogListSize: 20,
      currentLogListPage: 0,
      currentChannel: '',
      selectedUserIdLog: null,
      logSize: 50,
      socket: null,
      chatMode: 'auto',
      isBotActive: true,
      chatTextInput: '',
      mediaModalOpen: false,
      filteredLogList: [],
      menuConfig: dashboardConfig.getDefaultClientConfig(),
      interOb: null,
    };
  },
  async created() {
    this.menuConfig = await dashboardConfig.getConfig();
  },
  mounted() {
    this.selectedUserIdLog = null;
    this.loadAvailableChannel().then((data) => {
      const { channel } = data;
      if (channel && channel[0]) {
        const ch0 = channel[0];
        this.currentChannel = ch0;
      }
      this.emitSocket('cl_channel_join', this.currentChannel);
      this.loadModelList().then(() => {
        this.loadUserLog();
      });
    });

    //
    let sockUrl = `${alice.appPath || window.location.origin}/cl-sock`;
    const sockServerUrl = `${alice.appPath || ''}/sock`;
    if (window.location.hostname === 'localhost') {
      // sockUrl = 'http://localhost:3000/cl-sock';
      sockUrl = 'https://alice.ask-dom.com/cl-sock';
    }
    this.socket = io(sockUrl, {
      path: sockServerUrl,
      query: {
        token: '&V{Cp_U]B,3jpWc{Adq~',
      },
    });
    this.socket.on('connect', () => {
      // console.log('Connected');
    });
    this.socket.on('channel_message', (msg) => {
      // console.log('CH MESSAGE', msg);
      const { channel } = msg;
      if (channel === this.currentChannel) {
        if (this.selectedUserIdLog !== msg.user_id) {
          let currentUnread = {};
          if (this.unreadUserLogList) {
            currentUnread = JSON.parse(JSON.stringify(this.unreadUserLogList));
          }
          if (!currentUnread[channel]) {
            currentUnread[channel] = {};
          }
          if (!currentUnread[channel][msg.user_id]) {
            currentUnread[channel][msg.user_id] = [];
          }
          currentUnread[channel][msg.user_id].push(msg.created_at);
          this.setUnreadLogChannelList({
            channel,
            data: currentUnread[channel],
          });
          // If current log is this data - remove that state
          // setTimeout(() => {
          //   this.clearUnreadValue({
          //     channel: this.currentChannel, id: this.selectedUserIdLog,
          //   });
          // }, 300);
        }
        // TODO Then move the conversation in user list to the top
        this.updateLogAndMoveToTop({
          userId: msg.user_id,
          data: msg,
        }).catch(() => {
          // console.error('Error or No user in list - reloading', e);
          this.loadUserLog();
        });
      }
    });
    this.socket.on('user_message', (data) => {
      // console.log('USER MESSAGE', data);
      if (data.user_id === this.selectedUserIdLog) {
        // Update current log
        const messageData = {
          ...data,
        };
        this.pushToLogDetail([messageData]);
        this.scrollToBottom();
      }
    });
  },
  beforeDestroy() {
    try {
      this.socket.close();
      // console.log('Connection close succeed');
    } catch (e) {
      // console.log('Connection close failed');
    }
    if (this.interOb) {
      try {
        this.interOb.disconnect();
      } catch (e) {
        //
      }
    }
  },
  methods: {
    ...mapActions({
      loadModelList: 'model/loadModelList',
      loadLogList: 'log/loadLogList',
      loadLogDetail: 'log/loadLogDetail',
      resetLogDetail: 'log/resetLogDetail',
      loadAvailableChannel: 'log/loadAvailableChannel',
      pushToLogDetail: 'log/pushToLogDetail',
      updateLogAndMoveToTop: 'log/updateLogAndMoveToTop',
      setUnreadLogChannelList: 'persist/setUnreadLogChannelList',
      clearUnreadValue: 'persist/clearUnreadValue',
    }),
    getSearchInput: debounce(function() {
      this.currentLogListPage = 0;
      this.loadUserLog();
      // this.loadLogList({
      //   size: this.currentLogListSize,
      //   channel: this.currentChannel,
      //   unreadList: this.currentChannelUnreadLogList,
      //   page: this.currentLogListPage,
      //   // append: appendMode,
      //   userSearch: this.logSearchInput,
      // }).then((data) => {
      //   if (data && data.length) {
      //     this.filteredLogList = data;
      //   } else {
      //     this.filteredLogList = [];
      //   }
      //   this.$refs.userList.forceRender();
      // });
    }, 800),
    emitSocket(type, msg) {
      if (this.socket) {
        try {
          this.socket.emit(type, msg);
        } catch (e) {
          // console.log('Cannot emit ', type, msg);
        }
      }
    },
    loadUserLog(appendMode = false, cb) {
      // const regex = /U[0-9a-f]{32}/;

      this.loadingLog = true;
      this.loadLogList({
        size: this.currentLogListSize,
        channel: this.currentChannel,
        unreadList: this.currentChannelUnreadLogList,
        page: this.currentLogListPage,
        append: appendMode,
        userSearch: this.logSearchInput,
      }).then((data) => {
        // console.log('Data loaded');
        this.filteredLogList = data;
        if (!appendMode) {
          if (this.selectedUserIdLog === null && data.length > 0) {
            const first = data[0];
            this.selectLog(first.userId);
          }
          if (!this.initScrollStatus) {
            this.initScrollStatus = true;

            this.interOb = new IntersectionObserver(
              (entries) => {
                // console.log('UMMM', entries);

                for (const entry of entries) {
                  if (entry.isIntersecting) {
                    // console.log('On scroll to bottom', this.logDone, this.loadingLog);
                    if (!this.logDone && !this.loadingLog) {
                      this.loadingLog = true;
                      this.currentLogListPage += 1;
                      this.loadUserLog(true);
                    }
                  }
                }
              },
              {
                root: document.querySelector('#user-list'),
                rootMargin: '0px',
                threshold: 0.9,
              },
            );
            setTimeout(() => {
              this.interOb.observe(document.querySelector('#eol-user-list'));
            }, 500);
          }
        }
        if (cb) {
          cb();
        }
        this.loadingLog = false;
      });
    },
    resetSelectedState() {
      if (this.selectedUserIdLog !== null) {
        this.resetLogDetail();
      }
    },
    selectLog(userId) {
      const size = this.logSize;
      // Try leave room
      this.emitSocket('cl_room_leave', this.selectedUserIdLog);
      this.selectedUserIdLog = userId;
      const page = 0;
      this.loadingFirstDetail = true;
      this.loadLogDetail({
        userId,
        size,
        page,
      }).then(() => {
        // const lastIndex = data.content.length;
        // console.log('Detail loaded', lastIndex);
        this.scrollToBottom(0);
        this.scrollToBottom(200);
        setTimeout(() => {
          this.loadingFirstDetail = false;
        }, 300);
      });
      alice
        .getIsBotActive([
          {
            userId,
            channel: this.currentChannel,
          },
        ])
        .then((result) => {
          // console.log('OH select', result);
          if (result.data && Array.isArray(result.data.data) && result.data.data.length > 0) {
            // if (result.data[0].isBotActive) {
            //   this.chatMode = 'auto';
            // } else {
            //   this.chatMode = 'manual';
            // }
            this.isBotActive = result.data.data[0].isBotActive === true;
          }
        });
      // Try join room
      this.emitSocket('cl_room_join', this.selectedUserIdLog);
      // Clear unread value
      this.clearUnreadValue({
        channel: this.currentChannel,
        id: this.selectedUserIdLog,
      });
    },
    onUserLogListScroll(ev, data) {
      // console.log(ev, data.offset, data.offsetAll, this.logDone, this.loadingLog);
      if (!this.logDone && !this.loadingLog) {
        const offsetDiff = data.offsetAll - data.offset;
        // console.log('lOAD?', offsetDiff);

        // old offsetDiff 500
        if (offsetDiff <= 0) {
          this.loadingLog = true;
          this.currentLogListPage += 1;
          this.loadUserLog(true);
        }
      }
    },
    isTextMessage(item) {
      if (item.data && item.data.data_type && item.data.data_type === 'text_message') {
        return true;
      }
      return item.type === 'message' || item.type === 'send_message' || item.type === 'send_any_message';
    },
    isQuickReplyMessage(item) {
      if (item.data && item.data.data_type && item.data.data_type === 'quick_reply') {
        return true;
      }
      return item.type === 'send_quick_reply';
    },
    isButtonTemplateMessage(item) {
      if (item.data && item.data.data_type && item.data.data_type === 'button_template') {
        return true;
      }
      return item.type === 'send_button_template';
    },
    isImageMapMessage(item) {
      if (item.data && item.data.data_type && item.data.data_type === 'imagemap') {
        return true;
      }
      return item.type === 'send_imagemap';
    },
    isManualMessageType(item, type) {
      if (item.type === 'send_manual_message') {
        if (item.data && item.data.answers && item.data.answers[0] && item.data.answers[0].data_type === type) {
          return true;
        }
      }
      return false;
    },
    getManualLastMessage(data) {
      if (data.answers && data.answers[0]) {
        if (data.answers[0].text) {
          return 'sent a text message';
        }
        if (data.answers[0].imageUrl) {
          return 'sent a photo';
        }
        if (data.answers[0].videoUrl) {
          return 'sent a video';
        }
        if (data.answers[0].audioUrl) {
          return 'sent an audio';
        }
      }
      // console.log(data);
      return 'sent a message';
    },
    isImageMessage(item) {
      if (item.data && item.data.data_type && item.data.data_type === 'image') {
        return true;
      }
      return item.type === 'send_image' || item.type === 'image';
    },
    getMediaUrlField(item, type) {
      if (type === 'image') {
        if (this.isManualMessageType(item, 'image') || item.data.imageUrl) {
          return 'imageUrl';
        }
      } else if (type === 'video') {
        if (this.isManualMessageType(item, 'video') || item.data.videoUrl) {
          return 'videoUrl';
        }
      } else if (type === 'audio') {
        if (this.isManualMessageType(item, 'audio') || item.data.audioUrl) {
          return 'audioUrl';
        }
      }
      return 'url';
    },
    isVideoMessage(item) {
      if (item.data && item.data.data_type && item.data.data_type === 'video') {
        return true;
      }
      return item.type === 'send_video' || item.type === 'video';
    },
    isAudioMessage(item) {
      if (item.data && item.data.data_type && item.data.data_type === 'audio') {
        return true;
      }
      return item.type === 'send_audio' || item.type === 'audio';
    },
    isRuleBasedMessage(item) {
      if (item.data && item.data.data_type && item.data.data_type === 'rule_based_answer') {
        return true;
      }
      return item.type === 'send_alice_rule_based_answer' || item.type === 'send_selected_alice_rule_based_answer';
    },
    isLineFlexCarousel(item) {
      if (item.data && item.data.data_type && item.data.data_type === 'flex_message') {
        return true;
      }
      if (item && item.channel === 'line') {
        if (item.data && item.data.template && item.data.template.type) {
          return item.data.template.type === 'carousel';
        }
      }
      return false;
    },
    isFbCarousel(item) {
      if (item.data && item.data.data_type && item.data.data_type === 'carousel_template') {
        return true;
      }
      return false;
    },
    convertTime(time) {
      const timeObj = moment(time);
      if (timeObj.isSame(moment(), 'day')) {
        return timeObj.format('HH:mm');
      }
      return timeObj.format('D/M');
    },
    // eslint-disable-next-line func-names
    handleScroll: debounce(function(e) {
      // console.log(e);
      const { target } = e;

      const currentScroll = target.scrollTop;
      const currentHeight = target.scrollHeight;
      const scrollableDistance = Math.max(0, target.scrollHeight - target.offsetHeight);

      const ratio = currentScroll / scrollableDistance;
      // console.log('hdscroll', ratio);

      // got 20% upper - check for older
      // console.log('before', target.scrollHeight, target.scrollTop);
      if (!this.loadingDetail && ratio < 0.2) {
        try {
          this.loadingDetail = true;
          const totalPage = this.logDetail.totalPages;
          const currentPage = this.logDetail.pageable.pageNumber;
          // console.log(currentPage, '/', totalPage);
          if (currentPage < totalPage) {
            // console.log('Has older page - load more');
            const userId = this.selectedUserIdLog;
            const size = this.logSize;
            const page = currentPage + 1;
            const opt = {
              userId,
              size,
              append: true,
              page,
            };
            this.loadLogDetail(opt).then(() => {
              // console.log('Loaded');
              this.loadingDetail = false;
              // Current distance = target.scrollHeight - old target.scrollTop
              // console.log('after', target.scrollHeight, currentScroll);
              target.scroll({
                top: target.scrollHeight - currentHeight + currentScroll,
              });
            });
          } else {
            // console.log('No more data');
            this.loadingDetail = false;
          }
        } catch (ev) {
          // console.log('FUCK', ev);
          this.loadingDetail = false;
        }
      }
    }, 150),
    scrollToBottom(time = 500, fixScroll) {
      const target = document.getElementById('detail-scroller');
      setTimeout(() => {
        // console.log('trig2');
        if (fixScroll) {
          target.scrollTop = fixScroll;
        } else {
          target.scrollTop = target.scrollHeight + target.offsetHeight;
        }
      }, time);
    },
    changeChannel(ch) {
      if (this.currentChannel !== ch) {
        this.emitSocket('cl_channel_leave', this.currentChannel);
        this.currentChannel = ch;
        this.emitSocket('cl_channel_join', ch);
        this.resetSelectedState();
        this.selectedUserIdLog = null;
        this.currentLogListPage = 0;
        this.loadUserLog();
      }
    },
    // toggleChatMode(mode) {
    //   if (mode !== this.chatMode) {
    //     const userId = this.selectedUserIdLog;
    //     if (mode === 'manual') {
    //       alice
    //         .deactivateBot([
    //           {
    //             userId,
    //             channel: this.currentChannel,
    //             inActiveTime: 600,
    //           },
    //         ])
    //         .then(() => {
    //           // console.log(result);
    //           this.chatMode = mode;
    //         });
    //     } else if (mode === 'auto') {
    //       alice
    //         .activateBot([
    //           {
    //             userId,
    //             channel: this.currentChannel,
    //           },
    //         ])
    //         .then(() => {
    //           // console.log(result);
    //           this.chatMode = mode;
    //         });
    //     }
    //   }
    // },
    toggleIsBotActive(setIsBotActive) {
      if (setIsBotActive !== this.isBotActive) {
        const userId = this.selectedUserIdLog;
        if (setIsBotActive === false) {
          // MANUAL
          alice
            .deactivateBot([
              {
                userId,
                channel: this.currentChannel,
                inActiveTime: 600,
              },
            ])
            .then(() => {
              this.isBotActive = false;
            });
        } else {
          // AUTO
          alice
            .activateBot([
              {
                userId,
                channel: this.currentChannel,
              },
            ])
            .then(() => {
              this.isBotActive = true;
            });
        }
      }
    },
    handleTextMessageInput(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.sendChatTextMessage();
      }
    },
    sendManualMessage(messagesObj, logAnswers) {
      // console.log('Sending manual', messagesObj, logAnswers);
      const channel = this.currentChannel;
      const userId = this.selectedUserIdLog;
      alice
        .sendChatMessages({
          users: [{ userId, channel }],
          messages: messagesObj,
        })
        .then((res) => {
          // console.log('MANUAL', res);
          // TODO get real id / data for add to log
          const createdAt = parseInt(moment().format('x'), 10);
          let logId = `live-outgoing-${createdAt}`;
          try {
            logId = res.data.log.data.id;
          } catch (e) {
            // console.log('Cannot get log msg id');
          }
          const messageData = {
            id: logId,
            direction: 'outgoing',
            type: 'send_manual_message',
            created_at: createdAt,
            data: {
              answers: logAnswers,
            },
          };
          this.pushToLogDetail([messageData]);
          this.scrollToBottom();
          this.chatTextInput = '';
          this.updateLogAndMoveToTop({
            userId: res.data.log.data.user_id,
            data: res.data.log.data,
          }).catch(() => {
            // console.error('Error or No user in list - reloading', e);
            this.loadUserLog();
          });
        });
    },
    sendChatTextMessage(m) {
      const message = m || this.chatTextInput;
      const messagesObj = [
        {
          type: 'send_any_message',
          text: [message],
        },
      ];
      const logAnswers = [
        {
          data_type: 'text_message',
          text: message,
        },
      ];
      this.sendManualMessage(messagesObj, logAnswers);
    },
    onFileSelect(dataObj) {
      this.mediaModalOpen = false;
      // console.log(dataObj);
      const { url, thumbnailUrl, duration } = dataObj.result;
      let type;
      const messagesObj = [];
      const logAnswers = [];
      if (dataObj.type === 'others') {
        this.sendChatTextMessage(url);
      } else {
        if (dataObj.type === 'image') {
          type = 'send_image';
          logAnswers.push({ data_type: 'image', imageUrl: url });
        } else if (dataObj.type === 'audio') {
          type = 'send_audio';
          logAnswers.push({ data_type: 'audio', audioUrl: url });
        } else if (dataObj.type === 'video') {
          type = 'send_video';
          logAnswers.push({ data_type: 'video', videoUrl: url });
        }
        messagesObj.push({
          type,
          url,
          thumbnailUrl,
          duration,
        });
        this.sendManualMessage(messagesObj, logAnswers);
      }
    },
    getLogUserByDirection(log, outgoing, incoming) {
      if (log?.lastMessage?.direction === 'outgoing') {
        return outgoing || 'Bot: ';
      }
      return incoming || `${log?.userName || 'User'}: `;
    },
  },
  computed: {
    ...mapGetters({
      modelList: 'model/modelList',
      logListData: 'log/logListData',
      logList: 'log/logList',
      logDetail: 'log/logDetail',
      channelList: 'log/channelList',
      clientList: 'log/clientList',
      unreadUserLogList: 'persist/unreadUserLogList',
    }),

    // filteredLogList() {
    //   console.log('this.logList', this.logList);
    //   if (this.logList && this.logList.length > 0) {
    //     return this.logList.filter((data) => {
    //       if (this.logSearchInput) {
    //         const searchInput = this.logSearchInput.toLowerCase();
    //         const target = data.userName.toLowerCase();
    //         return target.indexOf(searchInput) > -1;
    //       }
    //       return true;
    //     });
    //   }
    //   return [];
    // },
    selectedLog() {
      if (this.filteredLogList && this.selectedUserIdLog !== null) {
        for (let i = 0; i < this.filteredLogList.length; i += 1) {
          if (this.filteredLogList[i].userId === this.selectedUserIdLog) {
            return this.filteredLogList[i];
          }
        }
      }
      return {};
    },
    currentChannelUnreadLogList() {
      if (this.currentChannel && this.unreadUserLogList) {
        return this.unreadUserLogList[this.currentChannel];
      }
      return {};
    },
    logDone() {
      if (this.logListData) {
        if (this.logListData.totalPage) {
          return this.currentLogListPage === this.logListData.totalPage - 1;
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.one-chat {
  .invincible {
    visibility: hidden;
  }
  .navbar-wrapper {
    .navbar {
      padding: 10px 0;
    }
  }
  .page-content {
    .conversation-list {
      overflow: hidden;
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 30%;
      position: relative;
      border-right: 1px solid #ddd;
      height: 100%;
      flex-direction: column;
      display: flex;

      .search-box {
        width: 100%;
        padding: 0.5rem 0 0.5rem 0.5rem;
        box-shadow: 0 1px 3px 0 rgba(100, 100, 100, 0.1);
        z-index: 10;
        border-bottom: 1px solid #ddd;
        margin-bottom: -1px;

        .search-bar {
          margin-right: 0;

          .input {
            border-radius: 5px;
            &.is-small {
              font-size: 0.8rem;
            }
          }
        }

        .change-conversation-btn {
          font-size: 1em;
          padding: 0 0.5em;
          height: 1.8em;
        }

        .chat-menu-item {
          padding: 10px;
        }
      }

      .list-wrapper {
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        width: 100%;
        .panel-block {
          border-right: none;
          border-left: none;
          border-bottom: 1px solid #efefef;
          // padding: 0.8rem;

          &:last-child {
            border-bottom: none;
          }

          position: relative;
          z-index: 9;
        }

        .media {
          width: 100%;
          padding-top: 8px;
          padding-bottom: 8px;
          .media-left {
            padding: 0;
            margin: 0 10px 0 0;

            .image {
              height: 48px;
              width: 48px;
              margin: 0;
            }
          }

          .media-content {
            height: 80px;
            max-height: 80px;
            overflow: hidden;
            display: flex;
            flex: 1 1 auto;
            .content-body {
              overflow: hidden;
              flex-direction: column;
              position: relative;
              padding-top: 3px;
              width: 100%;
            }
          }
        }

        .name-row,
        .text-row,
        .email-row {
          margin-bottom: 0;
          display: flex;

          .name-row-username,
          .text-row-text {
            display: flex;
            flex: 1 1 auto;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            .ellipsis-text {
              overflow: hidden;
              text-overflow: ellipsis;
              padding-right: 15px;
            }
          }

          .name-row-username {
            color: #555;
            font-weight: 500;
            font-size: 1rem;
            line-height: 1.4rem;
            .noti-dot {
              height: 1.15rem;
              margin-top: 0.1rem;
            }
          }

          .name-row-time {
            display: flex;
            flex: 1 1 auto;
            color: #aaa;
            font-size: 0.9rem;
            line-height: 1.4rem;
            font-weight: 500;
            white-space: nowrap;
            text-align: right;
            flex-grow: 0;
            flex-shrink: 1;
            flex-basis: initial;
            @media screen and (max-width: 768px) {
              display: none;
            }
          }

          .text-row-text {
            color: #777;
            font-size: 0.8rem;
            line-height: 1rem;
          }

          .email-row-text {
            color: #aaa;
            font-size: 0.75rem;
            line-height: 1rem;
          }

          .btn-wrapper {
            display: flex;
            flex: 0 0 auto;
            .archive-btn {
              .archive-btn-image {
                width: 1.2rem;
                height: 1.2rem;
              }
            }
          }
        }

        .panel-block.is-active {
          background: #f0f8ff;
        }

        .end-block {
          display: block;
          color: #7d7d7d;
          font-size: 0.85rem;
          text-align: center;
          background-color: #fafafa;
        }

        .loading-block {
          display: block;
          color: #616161;
          font-size: 1rem;
          text-align: center;
        }

        .head-block {
          color: #888;
          font-weight: 500;
          border-bottom: 0;
          padding: 10px 0 0 10px;
        }

        .is-circular-image {
          border-radius: 100px;
        }
      }
    }

    .conversation-detail {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;

      .title-bar {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        padding: 0.5rem 0.5rem 0.5rem 1rem;
        box-shadow: 0 1px 3px 0 rgba(100, 100, 100, 0.1);
        z-index: 10;
        border-bottom: 1px solid #ddd;
        margin-bottom: -1px;
        min-height: 45px;
        .label {
          margin: 0;
          line-height: 1.8rem;
          .email-title-bar {
            color: #aaa;
            font-size: 0.75rem;
            font-weight: 400;
          }
        }
        .right-tool {
          display: flex;
          .btn-group {
            position: relative;
            margin-left: 10px;
            min-width: 115px;
            background-color: #eee;
            border-radius: 20px;
            .btn {
              border-radius: 20px;
              min-width: fit-content;
              transition: box-shadow ease 0.5s;
              box-shadow: none;
            }
            .alpha-grey {
              background-color: transparent;
            }
            .bg-primary {
              box-shadow: inset 0 0 0 0 transparent;
            }
            .control-left-btn.alpha-grey {
              box-shadow: inset 100px 0 0 0 #eee;
            }
            .control-right-btn.alpha-grey {
              box-shadow: inset -100px 0 0 0 #eee;
            }
          }
        }
      }

      .detail-data {
        z-index: 5;
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .date-block {
        text-align: center;
        padding: 10px;
        margin: 10px;
        .date-text {
          padding: 5px 10px;
          font-size: 0.8rem;
          // background-color: rgba(250, 250, 250, 0.5);
          background-color: #efefef;
          border-radius: 10px;
        }
      }
      .generic-block {
        text-align: center;
        margin: 10px;
        padding: 10px;
        border-radius: 10px;
        background-color: #efefef;
        max-height: 50px;
        overflow: auto;
        .generic-text {
          font-size: 0.85rem;
        }
      }

      .chat-box {
        &.chat-box-hidden {
          display: none;
        }
        box-shadow: 0 -1px 3px 0 rgba(100, 100, 100, 0.1);
        border-top: 1px solid #ddd;
        display: flex;
        flex: 0 0 auto;
        flex-direction: column;
        .toolbar {
          text-align: left;
          background-color: #fafafa;
          font-size: 1.25em;
          .toolbar-btn {
            color: #333;
            margin: 0 0 0 10px;
            &.disabled {
              pointer-events: none;
              color: #ddd;
            }
          }
        }
        .textarea {
          resize: none;
          min-height: 50px;
          border-radius: 0;
          border-width: 0;
          &:focus {
            outline: none !important;
          }
        }
      }
    }

    .conv-not-selected {
      text-align: center;
      color: #aaa;
      margin-top: 2em;
      font-size: 0.9em;
    }
  }
}
</style>
